<template>
  
  <div>
    <div class="pt-5 pl-2">
      <DxChart
        id="chart"
        :data-source="dataSource"
        palette="Harmony Light"
        title="Pizza Shop Complaints"
      >
        <DxSize
          :height="giHeight"
          :width="giWidth"
        />
        <DxCommonSeriesSettings argument-field="complaint"/>
        <DxSeries
          name="Complaint frequency"
          value-field="count"
          axis="frequency"
          type="bar"
          color="#fac29a"
        />
        <DxSeries
          name="Cumulative percentage"
          value-field="cumulativePercentage"
          axis="percentage"
          type="spline"
          color="#6b71c3"
        />

        <DxArgumentAxis>
          <DxLabel overlapping-behavior="stagger"/>
        </DxArgumentAxis>

        <DxValueAxis
          :tick-interval="300"
          name="frequency"
          position="left"
        />
        <DxValueAxis
          :tick-interval="20"
          :show-zero="true"
          :value-margins-enabled="false"
          name="percentage"
          position="right"
        >
          <DxLabel :customize-text="customizePercentageText"/>
          <DxConstantLine
            :value="80"
            :width="2"
            color="#fc3535"
            dash-style="dash"
          >
            <DxLabel :visible="false"/>
          </DxConstantLine>
        </DxValueAxis>

        <DxTooltip
          :enabled="true"
          :shared="true"
          :customize-tooltip="customizeTooltip"
          />

          <DxLegend
            vertical-alignment="top"
            horizontal-alignment="center"
          />
        </DxChart>
    </div>
  </div>
</template>

<script>

import DxChart, {
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxLabel,
  DxLegend,
  DxSeries,
  DxTooltip,
  DxValueAxis,
  DxConstantLine,
  DxSize,
} from 'devextreme-vue/chart';

export default {
  props:{
    giHeight:Number,
    giWidth:Number,
   
  },
  components: {
    DxChart,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxLabel,
    DxLegend,
    DxSeries,
    DxTooltip,
    DxValueAxis,
    DxConstantLine,
    DxSize,
  },
  data() {
     const complaintsData = [
      { complaint: 'Cold pizza', count: 780 },
      { complaint: 'Not enough cheese', count: 120 },
      { complaint: 'Underbaked or Overbaked', count: 52 },
      { complaint: 'Delayed delivery', count: 1123 },
      { complaint: 'Damaged pizza', count: 321 },
      { complaint: 'Incorrect billing', count: 89 },
      { complaint: 'Wrong size delivered', count: 222 },
    ];
    const data = complaintsData.sort((a, b) => b.count - a.count);
    const totalCount = data.reduce((prevValue, item) => prevValue + item.count, 0);
    let cumulativeCount = 0;

    const dataSource = data.map((item) => {
      cumulativeCount += item.count;
      return {
        complaint: item.complaint,
        count: item.count,
        cumulativePercentage: Math.round((cumulativeCount * 100) / totalCount),
      };
    });

    return {
      dataSource,
    };
  },
  methods: {
    customizeTooltip(pointInfo) {
      return {
        html: `<div><div class='tooltip-header'>${
          pointInfo.argumentText
        }</div><div class='tooltip-body'><div class='series-name'><span class='top-series-name'>${
          pointInfo.points[0].seriesName
        }</span>: </div><div class='value-text'><span class='top-series-value'>${
          pointInfo.points[0].valueText
        }</span></div><div class='series-name'><span class='bottom-series-name'>${
          pointInfo.points[1].seriesName
        }</span>: </div><div class='value-text'><span class='bottom-series-value'>${
          pointInfo.points[1].valueText
        }</span>% </div></div></div>`,
      };
    },

    customizePercentageText({ valueText }) {
      return `${valueText}%`;
    },
  },
  mounted()
  {
    console.log(this.giHeight,this.giWidth);
  }
};
</script>

<style scoped>



</style>